module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIj48cGF0aCBmaWxsPSIjMDA3ZmZmIiBkPSJNMCAwaDgwMHY2MDBIMHoiLz48cGF0aCBkPSJNMzYgMTIwaDg0bDI2LTg0IDI2IDg0aDg0bC02OCA1MiAyNiA4NC02OC01Mi02OCA1MiAyNi04NC02OC01MnpNNzUwIDBMMCA0NTB2MTUwaDUwbDc1MC00NTBWMGgtNTAiIGZpbGw9IiNmN2Q2MTgiLz48cGF0aCBkPSJNODAwIDBMMCA0ODB2MTIwbDgwMC00ODBWMCIgZmlsbD0iI2NlMTAyMSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cod.svg
// module id = LR5p
// module chunks = 0